import classNames from 'classnames/bind';
import { useSearchParamsContext } from 'contexts/searchParams';
import React from 'react';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  className?: string;
  multiCity?: boolean;
  departure?: boolean;
  index: number;
  clickCodePrefix: string;
  onClick(): void;
}

export default function City({
  className,
  multiCity,
  departure,
  index,
  clickCodePrefix,
  onClick,
}: IProps) {
  const {
    searchParams: { itinerary },
    setActiveIndex,
  } = useSearchParamsContext();

  function handleClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    setActiveIndex(index);
    onClick();
  }

  const city = itinerary[index]?.[departure ? 'departureCity' : 'arrivalCity'];
  return (
    <button
      type="button"
      className={cx(className, 'City', {
        start: departure,
        end: !departure,
        as_multi: multiCity,
      })}
      aria-selected="false"
      data-event-nlog="click"
      data-event-area-code={`${clickCodePrefix}.${departure ? 'dep' : 'arr'}${index + 1}`}
      onClick={handleClick}
    >
      <b className={cx('code')} aria-selected="true">
        {city?.code ? city.code : departure ? '출발' : '도착'}
      </b>
      <i className={cx('name')}>{city?.name || '선택'}</i>
    </button>
  );
}
